/**
 * shop-product.js — DenimByte Product Page
 * Handles:
 *   1. Image gallery (thumbnail click → swap main image)
 *   2. Size selector (toggle selected pill)
 *   3. Accordion open/close (one open at a time)
 *   4. Add to Bag (AJAX cart add + 2s flash)
 *   5. Wishlist toggle (localStorage + UI state)
 */

(function () {
  'use strict';

  /* ══════════════════════════════════════════════
     COLOUR MAP — same as shop-featured.js
     Applies background colour to .shop-prod__color-swatch[data-color]
     ══════════════════════════════════════════════ */
  var COLOR_MAP = {
    black: '#0d0d0d', white: '#f9f9f9', navy: '#1e3a5f', red: '#b91c1c',
    blue: '#2563eb', green: '#16a34a', brown: '#92400e', grey: '#6b7280',
    gray: '#6b7280', beige: '#d4bfa0', cream: '#faf3e0', tan: '#c8a882',
    camel: '#c19a6b', khaki: '#c3b091', olive: '#808000', burgundy: '#800020',
    wine: '#722f37', rust: '#b7410e', orange: '#ea580c', yellow: '#ca8a04',
    pink: '#ec4899', purple: '#7c3aed', teal: '#0d9488', stone: '#78716c',
  };

  function applyColorSwatches() {
    document.querySelectorAll('.shop-prod__color-swatch[data-color]').forEach(function (el) {
      var color = el.getAttribute('data-color').toLowerCase().trim();
      var hex   = COLOR_MAP[color] || color;
      el.style.backgroundColor = hex;
    });
  }

  /* ══════════════════════════════════════════════
     PRELOAD GALLERY IMAGES
     Kick off background fetch for all secondary
     images so thumbnail clicks are instant (no delay).
     ══════════════════════════════════════════════ */
  function preloadGalleryImages() {
    var thumbs = document.querySelectorAll('.shop-prod__thumb[data-src]');
    thumbs.forEach(function (thumb) {
      var src = thumb.getAttribute('data-src');
      if (src) {
        var preloadImg = new Image();
        preloadImg.src = src; /* browser fetches + caches silently */
      }
    });
  }

  /* ══════════════════════════════════════════════
     IMAGE GALLERY
     ══════════════════════════════════════════════ */
  function initGallery() {
    var mainImg = document.getElementById('shop-prod-main-img');
    var thumbs  = document.querySelectorAll('.shop-prod__thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt') || '';
        if (src) {
          /* MUST clear srcset — browsers ignore src when srcset exists */
          mainImg.srcset = '';
          mainImg.src    = src;
          mainImg.alt    = alt;
        }
        /* Update active state */
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ══════════════════════════════════════════════
     SIZE SELECTOR
     ══════════════════════════════════════════════ */
  var selectedVariantId = null;

  function initSizeSelector() {
    var sizeBtns = document.querySelectorAll('.shop-prod__size-btn');
    var variantInput = document.getElementById('shop-prod-variant-id');
    var variants = (window.shopProductData && window.shopProductData.variants) || [];

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var size = btn.getAttribute('data-size');

        /* Toggle selected class */
        sizeBtns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        /* Find matching variant by size option */
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.options && v.options.indexOf(size) !== -1) {
            match = v;
            break;
          }
        }

        if (match) {
          selectedVariantId = match.id;
          if (variantInput) variantInput.value = match.id;
        }
      });
    });
  }

  /* ══════════════════════════════════════════════
     ACCORDION
     ══════════════════════════════════════════════ */
  function initAccordions() {
    var items = document.querySelectorAll('.shop-prod__acc-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('.shop-prod__acc-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        /* Close all */
        items.forEach(function (i) { i.classList.remove('is-open'); });

        /* Toggle clicked (open if was closed) */
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ══════════════════════════════════════════════
     ADD TO BAG (Shopify AJAX cart)
     ══════════════════════════════════════════════ */
  function initAddToCart() {
    var addBtn      = document.querySelector('.shop-prod__add-btn');
    var variantInput = document.getElementById('shop-prod-variant-id');
    if (!addBtn) return;

    addBtn.addEventListener('click', function () {
      var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (!variantId) return;

      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        /* ── "Added!" flash ── */
        var icon = addBtn.querySelector('.shop-prod__add-icon');
        var txt  = addBtn.querySelector('.shop-prod__add-text');
        addBtn.classList.add('is-added');
        if (txt) txt.textContent = 'Added to Bag!';

        /* Update cart count bubble if present */
        var cartCount = document.querySelector('[data-cart-count]');
        if (cartCount) {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              cartCount.textContent = cart.item_count;
              cartCount.setAttribute('data-cart-count', cart.item_count);
              cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
            });
        }

        setTimeout(function () {
          addBtn.classList.remove('is-added');
          addBtn.disabled = false;
          if (txt) txt.textContent = 'Add to Bag';
        }, 2000);
      })
      .catch(function (err) {
        console.error('Cart add error:', err);
        addBtn.disabled = false;
      });
    });
  }

  /* ══════════════════════════════════════════════
     WISHLIST (localStorage — stores product handles)
     Key: 'db_wishlist' → string[]  e.g. ['leather-jacket', 'hoodie']
     ══════════════════════════════════════════════ */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('db_wishlist') || '[]'); }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem('db_wishlist', JSON.stringify(list));
      /* Notify other scripts (e.g. header badge, wishlist page) */
      window.dispatchEvent(new CustomEvent('db:wishlist:change', { detail: { list: list } }));
    }
    catch (e) {}
  }

  function initWishlist() {
    /* Use handle as the stable wishlist key (needed for /products/${handle}.js fetches) */
    var handle      = window.shopProductData && window.shopProductData.handle;
    var imgWishlist = document.querySelector('.shop-prod__img-wishlist');
    var ctaWishlist = document.querySelector('.shop-prod__wishlist-cta');
    if (!handle) return;

    function isWishlisted() {
      return getWishlist().indexOf(handle) !== -1;
    }

    function updateUI() {
      var wishlisted = isWishlisted();

      if (imgWishlist) {
        imgWishlist.classList.toggle('is-wishlisted', wishlisted);
        imgWishlist.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Save to wishlist');
      }

      if (ctaWishlist) {
        ctaWishlist.classList.toggle('is-wishlisted', wishlisted);
        var ctaTxt = ctaWishlist.querySelector('.shop-prod__wishlist-text');
        if (ctaTxt) ctaTxt.textContent = wishlisted ? 'Saved to Wishlist' : 'Save to Wishlist';
      }
    }

    function toggle() {
      var list = getWishlist();
      var idx  = list.indexOf(handle);
      if (idx === -1) list.push(handle);
      else list.splice(idx, 1);
      saveWishlist(list);
      updateUI();
    }

    if (imgWishlist) imgWishlist.addEventListener('click', toggle);
    if (ctaWishlist) ctaWishlist.addEventListener('click', toggle);

    updateUI();
  }

  /* ══════════════════════════════════════════════
     INIT
     ══════════════════════════════════════════════ */
  function init() {
    preloadGalleryImages(); /* start fetching secondary images immediately */
    applyColorSwatches();
    initGallery();
    initSizeSelector();
    initAccordions();
    initAddToCart();
    initWishlist();
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
